import { render, staticRenderFns } from "./ModattaSvg.vue?vue&type=template&id=5135e122"
import script from "./ModattaSvg.vue?vue&type=script&lang=js"
export * from "./ModattaSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports